<div class="pageheader">
  <div class="page-title">
    <h1>Create Test Cases</h1>
  </div>
</div>

<!--TOO DOO use new controles when they support Signal Forms-->
<form (submit)="onSubmit($event)">
  <div class="container container-fixed">
    <div class="row">
      <div class="col-sm-4">
        <div class="form-group">
          <label>Name</label>
          <input id="testCaseName" class="form-control" [formField]="testCaseForm.Name" />
          @if (testCaseForm.Name().pending()) {
            <span class="spinner" aria-live="polite">Checking availability...</span>
          }
          @if (testCaseForm.Name().touched() && testCaseForm.Name().invalid()) {
            @for (error of testCaseForm.Name().errors(); track error) {
              <div class="error" role="alert">{{ error.message }}</div>
            }
          }
        </div>
        <div class="form-group">
          <label>Description</label>
          <input id="testCaseDescription" class="form-control" [formField]="testCaseForm.Description" />
          @if (testCaseForm.Description().touched() && testCaseForm.Description().invalid()) {
            @for (error of testCaseForm.Description().errors(); track error) {
              <div class="error" role="alert">{{ error.message }}</div>
            }
          }
        </div>
        <hr />
      </div>
    </div>
    
    <div class="row">
      <div class="col-sm-12">
        <button id="btnSave" class="btn btn-primary" type="submit">Save</button>
        <button id="btnCancel" class="btn btn-default" type="button" (click)="cancel()">Cancel</button>
      </div>
    </div>
  </div>
</form>
